<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>留言板</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main-pagination mg-tp10 mg-btm10">
            <el-button type="primary" @click="showRelease()" v-buttonAuth="'message:board:add'">发布留言</el-button>
        </div>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableConfig="tableForm.tableConfig"
                :tableData="tableForm.tableData" :loading="tableForm.isLoading">
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-buttonAuth="'message:board:details'"
                            @click="getDetails(scope.row)">详情</el-button>
                        <!-- <el-button type="text" v-buttonAuth="'message:board:reply'">回复</el-button> -->
                        <el-popconfirm title="是否删除数据？" @confirm="handleRemove(scope.row, 1)">
                            <template #reference>
                                <el-button type="text" class="col-f41"
                                    v-buttonAuth="'message:board:delete'">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog title="详情" :visible.sync="detailsVisible" :close-on-click-modal="false" custom-class="form-dialog"
            width="40%" @close='closeDialog()'>
            <div class="board-tree">
                <div class="board-first-node">
                    <div class="board-dom">
                        <div class="board-title">{{ detailsData.commentContent }}</div>
                        <div class="board-desc">
                            <span class="board-time">{{ detailsData.createTime }}</span>
                            <div class="board-btn">
                                <el-button type="text" @click="replayAction(detailsData)">回复</el-button>
                                <el-popconfirm title="是否删除数据？" @confirm="handleRemove(detailsData, 2)">

                                    <template #reference>
                                        <el-button type="text" v-if="detailsData.ableDelete"
                                            class="col-f41">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    <div class="board-dom mg-lef20" v-for="item in  detailsData.children" :key="item.leaveWordId">
                        <div class="board-heade">
                            <span>{{ item.createdBy.userName }}</span>
                            回复
                            <span>{{ item.replyOriginUserName }}</span>：
                        </div>
                        <div class="board-title">{{ item.commentContent }}</div>
                        <div class="board-desc">
                            <span class="board-time">{{ item.createTime }}</span>
                            <div class="board-btn">
                                <el-button type="text" @click="replayAction(item)">回复</el-button>
                                <el-popconfirm title="是否删除数据？" @confirm="handleRemove(item, 2)">

                                    <template #reference>
                                        <el-button type="text" v-if="item.ableDelete" class="col-f41">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    <div class="board-input" v-if="replyData.leaveWordId">
                        <el-input v-model="replyData.commentContent" placeholder="请输入回复内容"></el-input>&nbsp;
                        <el-button type="primary" :disabled="!replyData.commentContent"
                            @click="submitReply()">确定</el-button>
                        <el-button type="primary" @click="replyData = { commentContent: '' }">取消</el-button>
                    </div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <div></div>
            </div>
        </el-dialog>
        <el-dialog title="发布留言" :visible.sync="formVisible" :close-on-click-modal="false" custom-class="form-dialog"
            width="40%" @close='closeDialog()'>
            <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules"
                @submit="submitForm" :dataForm="formConfig.dataForm">
            </my-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='formVisible = false'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import MyTable from '@/components/myTable.vue';
import myForm from '@/components/myForm.vue';
import { boardPage, boardAdd, boardEdit, boardRemove, boardDetail } from '@/api/messageBoard.js'

export default {
    components: {
        MyTable,
        Pagination,
        myForm
    },
    data () {
        return {
            detailsVisible: false,
            formVisible: false,
            tableForm: {
                customColumns: [
                    {
                        label: '留言人', prop: 'createdBy',
                        formatter: (item) => { return item.userName }
                    },
                    { label: '留言标题', prop: 'title' },
                    { label: '留言内容', prop: 'commentContent' },
                ],

                tableConfig: {
                    isIndex: true,
                    noCheck: true,
                },
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            formConfig: {
                formItems: [
                    { type: 'input', prop: 'title', label: '标题' },
                    { type: 'textarea', prop: 'commentContent', label: '内容' },
                ],
                formRules: {
                    commentContent: [
                        { required: true, message: '请输入内容', trigger: 'blur' },
                    ],
                },
                dataForm: {
                    title: '',
                    commentContent: '',
                }
            },
            detailsData: {
                ableDelete: false,
            },
            replyData: {
                commentContent: '',
            }
        }
    },
    created () {
        this.getData()
    },
    methods: {
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
            }
            const res = (await boardPage(params)).data;
            this.tableForm.tableData = res.records;
            this.pageparm.total = res.total
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData()
        },
        closeDialog () {
            this.detailsVisible = false;
            this.formVisible = false;
            this.replyData = {
                commentContent: '',
            }
        },
        showRelease () {
            this.formVisible = true;
            this.formConfig.dataForm = {
                title: '',
                commentContent: '',
            };
        },
        async handleRemove (row, type = 1) {
            const res = await boardRemove(row.leaveWordId);
            if (type == 1) {
                this.getData()
            } else {
                this.getDetails(this.detailsData)
            }
            this.$message({ message: '删除成功', type: 'success' });
        },
        async getDetails (row) {
            const res = await boardDetail(row.leaveWordId);
            if (!res.data) {
                this.getData()
                this.closeDialog();
                return
            }
            this.detailsData = res.data;
            this.detailsVisible = true;
            this.replyData = {
                commentContent: '',
            }
        },
        replayAction (item) {
            this.replyData = JSON.parse(JSON.stringify(item));
            this.replyData['commentContent'] = '';
        },
        submitForm () {
            const data = this.formConfig.dataForm;
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    const res = await boardAdd(data);
                    this.closeDialog();
                    await this.getData();
                    this.$message.success(res.msg);
                } else {
                    return false
                }
            })
        }
        ,
        async submitReply () {
            const params = {
                commentContent: this.replyData.commentContent,
                replyOriginLeaveWordId: this.replyData.leaveWordId,
                title: this.replyData.title,
            }
            const res = await boardAdd(params);
            this.getDetails(this.detailsData)
        }
    }
}
</script>

<style lang="scss" scoped>
.board-tree {
    margin: 40px;

    .board-first-node {
        .board-dom {
            display: flex;
            margin-top: 10px;
            flex-direction: column;

            &:not(:first-child) {
                padding-left: 30px;
            }

            .board-heade {
                display: flex;
                align-items: center;
                font-size: 25px;

                span {
                    color: #04018A;
                    padding: 0 2px;
                }
            }

            .board-title {
                margin-bottom: 5px;
                font-size: 25px;
            }

            .board-desc {
                display: flex;
                align-items: center;

                .board-time {
                    font-size: 22px;
                    margin-right: 15px;
                }
            }
        }

        .board-input {
            display: flex;
            align-items: center;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/message/board.vue